import { LGraphNode, LiteGraph } from "litegraph.js";
import { addDrivableSlider, finalizeDrivableSliders, syncDrivableSliders } from "../utils/addDrivableSlider.js";

/**
 * BlendModeNode
 * -------------
 * Composites two canvas inputs using CSS blend modes.
 */
export class BlendModeNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Blend Mode";

    this.properties = {
      mode: "multiply",
      opacity: 1,
    };

    this.addInput("Canvas A", "canvas");
    this.addInput("Canvas B", "canvas");
    this.addOutput("Canvas", "canvas");

    this.addWidget("combo", "Mode", "multiply", (val) => {
      this.properties.mode = val;
    }, {
      values: [
        "multiply", "screen", "overlay", "darken", "lighten",
        "color-dodge", "color-burn", "hard-light", "soft-light",
        "difference", "exclusion", "hue", "saturation", "color", "luminosity"
      ]
    });

    addDrivableSlider(this, "Opacity", "opacity", 1, 0, 1, 0.01);

    finalizeDrivableSliders(this, 2);

    this._outCanvas = document.createElement("canvas");
    this._outCtx = this._outCanvas.getContext("2d");

    this.size = [200, 100];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onExecute() {
    syncDrivableSliders(this);

    const a = this.getInputData(0);
    const b = this.getInputData(1);
    if (!a) { this.setOutputData(0, null); return; }

    const w = a.width;
    const h = a.height;
    if (this._outCanvas.width !== w) this._outCanvas.width = w;
    if (this._outCanvas.height !== h) this._outCanvas.height = h;

    const ctx = this._outCtx;
    ctx.clearRect(0, 0, w, h);

    // Draw base layer
    ctx.globalCompositeOperation = "source-over";
    ctx.globalAlpha = 1;
    ctx.drawImage(a, 0, 0);

    // Blend second layer on top
    if (b) {
      ctx.globalCompositeOperation = this.properties.mode;
      ctx.globalAlpha = this.properties.opacity;
      ctx.drawImage(b, 0, 0, w, h);
      ctx.globalCompositeOperation = "source-over";
      ctx.globalAlpha = 1;
    }

    this.setOutputData(0, this._outCanvas);
  }
}

LiteGraph.registerNodeType("composite/BlendMode", BlendModeNode);
